import { listDefaultProps as originalListDefaultProps } from '@regular_ui/lib/components/list/default-props';
import { LengthUnit } from '@regular_ui/lib/definitions';

export const listDefaultProps = {
  ...originalListDefaultProps,
  spacingUnit: LengthUnit.Rem,
};
